import { selectProducts } from 'Favourites/store/reducers/data/products';

export default class RetailItemComm {
    REGULAR_TYPE = 'regularPrice';
    FAMILY_TYPE = 'familyPrice';
    DISCOUNT_TYPE = 'promotionPrice';

    getUnitPrice(productState, priceType, excludeVAT) {
        return Number(this._getPriceData(productState, priceType, excludeVAT).price);
    }

    getTotalProductPrice(productState, priceType, excludeVAT) {
        return this.getUnitPrice(productState, priceType, excludeVAT) * productState.quantity;
    }

    getPriceExpirationDate(productState, priceType, excludeVAT) {
        return this._getPriceData(productState, priceType, excludeVAT).ValidToDateTime;
    }

    getOldPrice(productState, priceType, excludeVAT) {
        return this._getPriceData(productState, priceType, excludeVAT).oldPrice || false;
    }
    getOrderTotal(state, priceType, excludeVAT) {
        const products = selectProducts(state);
        let total = 0;
        let hasFamilyProducts = false;

        for (const key in products) {
            hasFamilyProducts = hasFamilyProducts || products[key].familyPrice;
            let priceData = this._getPriceData(products[key], priceType, excludeVAT);

            if (priceType === this.FAMILY_TYPE && !priceData) {
                priceData = this._getPriceData(products[key], this.REGULAR_TYPE, excludeVAT);
            }

            total += (priceData.price || 0) * (products[key].quantity || 0);
        }

        if (priceType === this.FAMILY_TYPE && !hasFamilyProducts) {
            return 0;
        }
        return total;
    }

    getOrderTotalVAT() {
        // TODO retrieve total VAT
        return false;
    }

    getOrderGrandTotal(state, priceType, excludeVAT) {
        return this.getOrderTotal(state, priceType, excludeVAT);
    }

    getOrderGrandTotalVAT() {
        // TODO retrieve grand total VAT
        return false;
    }

    isDiscounted() {
        return false;
    }

    isTRO(productState, priceType, excludeVAT) {
        return this._getPriceData(productState, priceType, excludeVAT).tro || false;
    }

    isNLP(productState, priceType, excludeVAT) {
        return this._getPriceData(productState, priceType, excludeVAT).newLowerPrice || false;
    }

    _getPriceData(productState, priceType, excludeVAT) {
        const priceProperty = priceType + (excludeVAT ? 'WithoutVAT' : '');
        if (!productState.hasOwnProperty(priceProperty)) {
            return false;
        }

        return productState[priceProperty];
    }
}
